import React, { Fragment } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Yoga = () => {

    return (
        <Fragment>
            <Header />
            <div class="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Yoga Retreats</h1>
                        <div class="breadcumb-menu-wrap">
                            <ul class="breadcumb-menu">
                                <li><a href="/">Home</a></li>
                                <li>Yoga Retreats</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section class="space">
                <div class="container">
                    <div class="row align-items-center sprituality-box">
                        <div class="col-lg-12">
                            <div class="about-content sprituality-content text-center">
                                <div class="title-area">
                                    <span class="sec-subtitle">Time to pause and breathe</span>
                                    <h2 class="sec-title h1">Move a Little. Breathe a Lot.</h2>
                                    <p class="sec-text">Life moves fast. Sometimes too fast. Our yoga retreats give you space to slow down, stretch out, and just be without needing to check your phone, answer emails, or keep up with anything. It's not about being flexible or “good” at yoga. It`s about showing up for yourself.</p>
                                    <p class="sec-text">These retreats are simple, peaceful, and grounded. You`ll practice yoga and meditation each day, eat clean, nourishing food, rest properly, and connect with the present moment — not through pressure, but through gentle routine.</p>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="about-content sprituality-content">
                                <div class="title-area">
                                    <p class="sec-text"><b>What to Expect</b></p>
                                    <p class="sec-text">We host retreats in quiet, natural places — often near forests, hills, or rivers. Most days include a morning yoga session, guided meditation, and time for yourself. You might take a walk in nature, journal, read, or just sit with a cup of tea and not rush.</p>
                                    <p class="sec-text">There`s no loud schedule or performance just a rhythm that helps you settle into your body and mind again.</p>
                                </div>
                                <p class="sec-text"><b>Who Is This For?</b></p>
                                <ul class="about-list1">
                                    <li>Anyone feeling tired, anxious, or mentally crowded</li>
                                    <li>Beginners and experienced yoga practitioners alike</li>
                                    <li>People who want more than a holiday but less than a strict program</li>
                                    <li>Those looking for gentle structure, good food, and calm surroundings</li>
                                </ul>
                                <a href="destination" class="vs-btn style4">Know More</a>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="image-box1">
                                <img class="img1" src="assets/img/added/yoga-1.png" alt="image1" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

           
            <Footer />
        </Fragment>
    );
}

export default Yoga;